<div class="media-viewer">
  <div class="media-viewer-header">
    <span class="media-viewer-header-title">{{ activeFile?.name }}</span>
    <div class="media-viewer-header-actions">
      <button (click)="download()"
              matTooltip="Завантажити"
              mat-icon-button>
        <mat-icon>file_download</mat-icon>
      </button>

      <button mat-icon-button
              aria-label="Close modal"
              matDialogClose>
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <div class="media-viewer-content">
    <button mat-icon-button
            class="media-viewer-content-nav"
            [disabled]="!hasPrev"
            (click)="prev()">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <div class="media-viewer-content-image-wrapper">
      <img *ngIf="activeFile"
           [src]="activeFile.safeUrl"
           [alt]="activeFile.name"
           class="media-viewer-content-image">
    </div>

    <button mat-icon-button
            class="media-viewer-content-nav"
            [disabled]="!hasNext"
            (click)="next()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <div class="media-viewer-thumbnails">
    <div *ngFor="let file of files; let i = index"
         class="media-viewer-thumbnails-item"
         [class.media-viewer-thumbnails-item-active]="i === activeIndex"
         (click)="selectFile(i)">
      <img class="media-viewer-thumbnails-item-image"
           [src]="file.safeUrl"
           [alt]="file.name">
    </div>
  </div>
</div>
